var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "System Icon / Notifications / Designs / Confirmation / Tick Circled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20210818_Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0-Coverage-/-1.0-Pass-/-2.0-FrequencyDropdown",
    transform: "translate(-185.000000, -1893.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Promo-code",
    transform: "translate(185.000000, 1856.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form---Validation---Designs",
    transform: "translate(0.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4F9F31",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-73-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8.71304939 11.177835 7.28695061 12.5800626 11.0669051 16.4243661 17.7111729 9.70301712 16.2888271 8.29698288 11.0707121 13.5756339"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidMessage);
export default __webpack_public_path__ + "static/media/valid-message.db427cc5b4c5f0f2ca57125c713f8e27.svg";
export { ForwardRef as ReactComponent };